/* eslint-disable import/extensions */
import environmentVariables from '../env';

export default {
  // Local storage key value of Selected building list
  SHOW_COVID_BANNER: false,
  ...environmentVariables
};
